var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import find from 'lodash/find';
import * as PropTypes from 'prop-types';
import * as React from 'react';
import Popover from '../popover';
import { devicesList, platformList } from './devices-list';
import defaultSVG from './img/default.svg';
import platformAmazon from './img/platform-amazon.svg';
import platformAndroid from './img/platform-android.svg';
import platformChromeos from './img/platform-chromeos.svg';
import platformIos from './img/platform-ios.svg';
import platformMac from './img/platform-mac.svg';
import platformLinux from './img/platform-linux.svg';
import platformWindows from './img/platform-windows.svg';
import { Styled } from './style';
var defaultPlatform = {
    'platform-amazon': platformAmazon,
    'platform-android': platformAndroid,
    'platform-chromeos': platformChromeos,
    'platform-mac': platformMac,
    'platform-ios': platformIos,
    'platform-windows': platformWindows,
    'platform-linux': platformLinux,
    'default': defaultSVG,
};
var DeviceIcon = /** @class */ (function (_super) {
    __extends(DeviceIcon, _super);
    function DeviceIcon(props) {
        return _super.call(this, props) || this;
    }
    DeviceIcon.prototype.render = function () {
        var _a = this.props, platform = _a.platform, model = _a.model;
        var matchIcon = devicesList.filter(function (device) { return device.model === model; });
        var deviceName = (matchIcon.length && matchIcon[0].name) || model;
        var platformData = find(platformList, { platform: this.props.platform });
        var iconName;
        var iconUrl;
        if (model !== undefined && model !== '' && matchIcon.length > 0 && matchIcon[0].src !== '') {
            iconUrl = matchIcon[0].src;
        }
        else {
            switch (platform) {
                case 'amazon':
                    iconName = 'platform-amazon';
                    break;
                case 'android':
                    iconName = 'platform-android';
                    break;
                case 'chromeos':
                    iconName = 'platform-chromeos';
                    break;
                case 'mac':
                case 'osx':
                    iconName = 'platform-mac';
                    break;
                case 'ios':
                    iconName = 'platform-ios';
                    break;
                case 'windows':
                    iconName = 'platform-windows';
                    break;
                default:
                    iconName = 'default';
                    break;
            }
            iconUrl = defaultPlatform[iconName];
        }
        if (this.props.showDetails) {
            return React.createElement(Popover, { trigger: React.createElement(Styled, { icon: iconUrl }), content: React.createElement("div", { className: "device-info" },
                    React.createElement("h3", null, deviceName !== null && deviceName !== void 0 ? deviceName : "Unknown Device"),
                    React.createElement("span", null, platformData ? platformData.name : 'Unknown Platform'),
                    this.props.player_width && this.props.player_height &&
                        (React.createElement("span", null,
                            this.props.player_width,
                            "x",
                            this.props.player_height))), position: "bottom left", inverted: true });
        }
        else {
            return React.createElement(Styled, { icon: iconUrl });
        }
    };
    DeviceIcon.propTypes = {
        model: PropTypes.string,
        name: PropTypes.string,
        platform: PropTypes.string,
    };
    return DeviceIcon;
}(React.PureComponent));
export default DeviceIcon;
//# sourceMappingURL=index.js.map